const styles = theme => ({
    panelMessage: {
        marginTop: '5%',
        marginLeft: '10%',
        marginRight: '10%',
        [theme.breakpoints.down('lg')]: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            marginTop: '10%',
        }
    },
    body: {
        backgroundColor: theme.palette.background.default,
        padding: 0
    },
    swipeList: {
        paddingTop: 0,
        paddingBottom: 0,
        borderLeft: 'solid 1px gainsboro',
        borderRight: 'solid 1px gainsboro',
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    filterPanel: {
        padding: theme.spacing(2),
        background: theme.palette.secondary.light,
        marginBottom: theme.spacing(1),
    }
});

export default styles;